import { cva } from 'class-variance-authority';

export { default as NavigationMenu } from './NavigationMenu.vue';
export { default as NavigationMenuContent } from './NavigationMenuContent.vue';
export { default as NavigationMenuItem } from './NavigationMenuItem.vue';
export { default as NavigationMenuLink } from './NavigationMenuLink.vue';
export { default as NavigationMenuList } from './NavigationMenuList.vue';
export { default as NavigationMenuTrigger } from './NavigationMenuTrigger.vue';
export { default as NavigationMenuViewport } from './NavigationMenuViewport.vue';

export const navigationMenuTriggerStyle = cva(
  'group inline-flex h-fit uppercase w-max items-center justify-center bg-background p-4 text-sm font-medium transition-colors hover:bg-anti-flash-white focus:bg-anti-flash-white [&:has(:focus-visible)]:ring-4 disabled:pointer-events-none disabled:opacity-50 text-stormcloud'
);
